import { useFocusTrapManager } from '@/utils/focusTrapManager';

export default defineNuxtPlugin(() => {
  const focusTrapManager = useFocusTrapManager();

  return {
    provide: {
      focusTrapManager,
    },
  };
});
